import { FeaturedContentType } from '@components/FeaturedContentCardGrid';
import { Document } from '@contentful/rich-text-types';
import { ShopNavigationOptions } from '@data/shops';
import { ReactNode } from 'react';

export interface Props {
  key?: string;
  id?: string;
  dataTestId?: string;
  evaId?: string;
  contentTypeId?: string;
  shop?: any;
  nerenComplianceNode?: any;
  // ----- CUSTOM UNIQUE PROP TYPES BELOW -----
  customBtns?: any;
  country?: string;
  member?: any;
  searchLanguage?: string;
  searchPlaceholderText?: string;
  showNewestListings?: boolean;
  showLicenseNumber?: boolean;
  custom14?: any;
  custom15?: any;
  children?: any;
  title?: string;
  baseCurrency?: string;
  // mainComponent is a single component
  mainComponent?: ReactNode | null;
  secondaryComponents?: ReactNode[] | null;
  pageData?: any;
  shopData?: any;
  chimeData?: any;
  locale?: string;
  embedCode?: string;
  async?: boolean;
  zipCode?: string;
  similarEntries?: any[];
  page?: any;
  fields?: any;
  articles?: any[];
  mentions?: any[];
  pageType?: string;
  name?: string;
  resoId?: string;
  disclaimer?: string;
  defaultCurrency?: string;
  className?: string;
  swatch?: string;
  backgroundColor?: boolean | string;
  reverse?: boolean;
  pagination?: boolean;
  formHeader?: string;
  formDescription?: any;
  setFormSuccess?: React.Dispatch<React.SetStateAction<boolean>>;
  handleDownloadClick?: any;
  eyebrowSidebar?: string;
  headerSidebar?: string;
  bodySidebar?: any;
  location?: string;
  caption?: string;
  slug?: string;
  url?: string;
  urlBase?: string;
  urlPrepend?: string;
  header?: string;
  header2?: string;
  subheader?: string;
  subheaders?: string | string[];
  eyebrow?: string;
  eyebrow2?: string;
  category?: string;
  img?: any;
  img1?: any;
  img2?: any;
  imgs?: any;
  publicationLogo?: string;
  source?: string;
  imageAspectRatio?: number | number[];
  imgFocalPoint?: any;
  bodyText?: string | object | Document;
  bodyText2?: string;
  links?: any;
  linksSidebar?: any;
  downloadLink?: string;
  cta?: { text: string; url: string }[];
  ctaUrlTarget?: boolean;
  ctaUrl?: string;
  ctaUrl2?: string;
  ctaText?: string;
  ctaText2?: string;
  alt_text?: string;
  cardArr?: any[];
  media?: any;
  placeholderMedia?: any;
  separator?: boolean;
  searchLink?: boolean;
  PropertyCountLimit?: number;
  tags?: {
    name: string;
    slug: string;
  }[];
  handleSearch?: (search: string) => void;
  handleTagClick?: (tag: string) => void;
  refreshProperties?: ({
    listingId,
    listOfficeMlsId,
    remove,
  }: {
    listingId: string;
    listOfficeMlsId: string;
    remove: boolean;
  }) => void;
  urlParamSearch?: string;
  urlParamTag?: string;
  cardsPerPage?: number;
  author?: string;
  publicationDate?: string;
  buttonExternalOption?: boolean;
  buttonExternalOption2?: boolean;
  imageCircle?: boolean;
  imageCircle2?: boolean;
  contentCard?: {
    img: string;
    title: string;
    description: string;
  }[];
  people?: {
    key?: string;
    img: string;
    name: string;
    description: string;
    ctaUrl: string;
    ctaText: string;
  }[];
  flexCollarSlides?: {
    header?: string;
    img?: string;
    url?: string;
  }[];
  lifestyles?: {
    key?: string;
    header?: string;
    img?: string;
    url?: string;
  }[];
  testimonials?: {
    title: string;
    text: string;
    author: string;
  }[];
  drawers?: {
    header?: string;
    sections?: {
      subheader?: string;
      list?: string[]; // if it's a list
      columns?: [
        // is an array of strings
        string[],
      ];
    }[];
    description?: string; // if just string
  }[];
  jobListings?: {
    title: string;
    type: string;
    level: string;
    location: string;
    timeListed: string;
    url: string;
  }[];
  videoSrc?: string;

  // Search Hero
  propertyImages?: any[];

  // variant stat text image block
  statHeader?: string;
  percentage?: number;
  statNumber?: number;
  prepend?: string;
  append?: string;
  stats?: {
    key?: string;
    statNumber: number;
    subheader: string;
    prepend?: string;
    append?: string;
    percentage?: number;
  }[];

  // Video
  video_source?: boolean;
  youTubeUrl?: string;
  videoUpload?: string;
  posterImage?: string;
  videoIcon?: string;
  muted?: boolean;
  loop?: boolean;
  controls?: boolean;
  playing?: boolean;
  videoSubject?: string; // might change based on how advisors are entered
  videoSubjectDetails?: string | string[];
  videos?: any; // this is an array that consists of the above video fields, set to 'any' for now
  mlsComplianceObj?: any;
  // Blog Detail Text
  dropCap?: boolean;
  richText?: Document; // TO DO: Add Type
  bodyRichText?: Document; // TO DO: Add Type

  //Listings
  shopId?: string;
  shopIds?: string;
  contentfulTagIds?: string;
  chimeId?: string;
  chimeType?: string;
  ownershipId?: string;
  ownershipScope?: string;
  closePriceToDisplay?: string;
  listPrice?: string;
  listUrl?: string;
  listingId?: string;
  openHouse?: [];
  listingStatus?: string;
  propertySubType?: string;
  propertyType?: string;
  address?: string;
  bathrooms?: string;
  bedrooms?: string;
  squareFeet?: number;
  squareFootage?: string;
  squareMeterPreference?: boolean;
  acreage?: string;
  listOfficeName?: string;
  listOfficeUrl?: string;
  listAgentFullName?: string;
  listAgentURL?: string;
  originatingSystemName?: string;
  listAgentEmail?: string;
  buyerAgentFullName?: string;
  buyerOfficeName?: string;
  attributionContact?: string;
  isFavorite?: boolean;
  favId?: string;
  lifestyle?: string;
  grid?: number;
  statBlockProps?: string[];
  select?: string[];

  // Featured Content
  featuredContent?: FeaturedContentType[];
  contentHeader?: string;
  viewAllContentButtonText?: string;
  viewAllContentSlug?: string;
  showViewAllContentButton?: boolean;

  // Neighborhood
  isShopOrShopGroupPage?: boolean;
  neighborhoods?: any;
  neighborhoodId?: string;
  coordinates?: {
    lat: number;
    lng: number;
  };
  developmentIds?: string[];
  countryCode?: string;
  geogId?: string;
  // Listing Highlights
  tabs?: {
    type: 'standard' | 'community' | 'school';
    header: string;
    tabListings: {
      header?: string;
      bodyText?: string;
      img?: any;
      rating?: number;
      students?: string;
      distance?: string;
      reviewAvg?: number;
      reviewNum?: number;
      content?: string;
    }[];
  }[];

  // Article Carousel
  altHeader?: boolean;
  slides?: {
    img?: any;
    headline?: string;
    date?: string;
    bodyText?: any; //TODO: change to BasicText | string | ReactNode once that is setup properly
    alt_text?: string;
    url?: string;
    imageAspectRatio?: number;
    tags?: {
      slug: string;
      name: string;
    }[];
  }[];

  //Value Prop Card Content
  headline?: string;
  valuePropCardContent?: {
    cardImage: string;
    cardHeadline?: string;
    cardSubHeadline?: string;
    cardDescription: string;
  }[];
  //Value Prop Card Content ALT
  valuePropCardContentAlt?: {
    cardImage: string;
    cardHeadline?: string;
    cardSubHeadline?: string;
    cardDescription: string;
    links?: any;
  }[];
  config?: any;
  newSearchUrl?: string;
  heading?: string;
  subHeading?: string;
  defaultValue?: number;
  shopMlsId?: string;
  currencyCode?: string;
  userData?: {
    firstName?: string;
    lastName?: string;
    phone?: string;
    email?: string;
  };
  isSVG?: boolean;
  internalName?: string;
  description?: string;
  contact1Title?: string;
  contact1Subtitle?: string;
  contact1Phone?: string;
  contact1Name?: string;
  contact1Image?: string;
  contact1Email?: string;
  contact2Title?: string;
  contact2Subtitle?: string;
  contact2Phone?: string;
  contact2Name?: string;
  contact2Image?: string;
  contact2Email?: string;
  isStarIconVisible?: boolean;
  extraGutterWidth?: boolean;
  brokeragePhone?: string;
  includeBrokeragePhone?: boolean;
  isCooperativeAgency?: boolean;
  isExternal?: boolean;
  cooperativeAgencyName?: string;
  hideRentFilters?: boolean;
  shopNavigationOptions?: ShopNavigationOptions;
  isStackedImageForm?: boolean;
  blogType?: string;
}

export const MapProps = <T extends any = any>(block: any): T => {
  if (block == null || !block.fields) return {} as T;
  const {
    // name,
    // resoId,
    // disclaimer,
    title,
    cta,
    downloadLink,
    header,
    header2,
    img,
    img2,
    media,
    placeholderMedia,
    publicationLogo,
    videoUpload,
    posterImage,
    people,
    contentCard,
    flexCollarSlides,
    testimonials,
    jobListings,
    author,
    richText,
    images,
    propertyImages,
    tabs,
    valuePropCardContent,
    valuePropCardContentAlt,
    select,
    heading,
    subHeading,
    contact1Image,
    contact2Image,
  } = block.fields;
  let BlockMap = {
    // key: block.sys.id,
    id: block.sys.id,
    contentTypeId: block.sys.contentType.sys.id,
    // ----- CUSTOM UNIQUE PROPS BELOW -----
    // IMPORTANT NOTE: only add props that are not equal to itself
    cta: cta?.map((obj) => {
      const { url, text } = obj.fields;
      return {
        url: url,
        text: text,
      };
    }),
    downloadLink: downloadLink?.map((obj) => {
      const { url } = obj.fields;
      return {
        url: url,
      };
    }),
    header: header || title,
    header2: header2 || title,
    img: img?.fields?.file?.url,
    img2: img2?.fields?.file?.url,
    media: {
      url: media?.fields?.file?.url,
      fileName: media?.fields?.file?.fileName,
    },
    placeholderMedia: {
      url: placeholderMedia?.fields?.file?.url,
      fileName: placeholderMedia?.fields?.file?.fileName,
    },
    publicationLogo: publicationLogo?.fields?.file?.url,
    alt_text: img?.fields?.description,
    videoUpload: videoUpload?.fields?.file?.url,
    posterImage: posterImage?.fields?.file?.url,
    author: author,
    contentCard: contentCard?.map((obj) => {
      const { fields } = obj;
      const img = fields?.img?.fields?.file?.url;
      const title = fields?.title;
      const description = fields?.description;
      return {
        img,
        title,
        description,
      };
    }),
    testimonials: testimonials?.map((obj) => {
      const { fields } = obj;
      const title = fields?.title;
      const text = fields?.text;
      const author = fields?.author;
      return {
        title,
        text,
        author,
      };
    }),
    jobListings: jobListings?.map((obj) => {
      const { fields } = obj;
      const title = fields?.title;
      const type = fields?.type;
      const level = fields?.level;
      const location = fields?.location;
      const timeListed = fields?.timeListed;
      const url = fields?.url;
      return {
        title,
        type,
        level,
        location,
        timeListed,
        url,
      };
    }),
    people: people?.map((obj) => {
      const { fields } = obj;
      const img = fields?.img?.fields?.file?.url;
      const name = fields?.name;
      const description = fields?.description;
      const ctaUrl = fields?.ctaUrl;
      const ctaText = fields?.ctaText;
      return {
        img,
        name,
        description,
        ctaUrl,
        ctaText,
      };
    }),
    flexCollarSlides: flexCollarSlides?.map((s) => {
      const { fields } = s;
      const header = fields?.header;
      const img = fields?.img?.fields?.file?.url;
      const url = fields?.url;
      return {
        header,
        img,
        url,
      };
    }),
    richText,
    imgs: images?.map((i) => i?.fields?.file?.url),
    propertyImages: propertyImages?.map((p) => {
      const { fields } = p;
      const key = fields?.key;
      const header = fields?.header;
      const subHeader = fields?.subhead;
      const ctaUrl = fields?.ctaUrl;
      const image = fields?.image?.fields?.file?.url;
      const source = fields?.source;
      const videoSrc = fields?.videoSrc;
      const videoUpload = fields?.videoUpload?.fields?.file?.url;

      return {
        key,
        header,
        subHeader,
        ctaUrl,
        image,
        source,
        videoSrc,
        videoUpload,
      };
    }),
    tabs: tabs?.map((t) => ({
      type: t?.fields?.type,
      header: t?.fields?.header,
      tabListings: t?.fields?.items.map((i) => ({
        header: i?.fields?.header,
        bodyText: i?.fields?.bodyText,
        img: `https:${i?.fields?.img?.fields?.file?.url}`,
        rating: i?.fields?.rating,
        students: i?.fields?.students,
        distance: i?.fields?.distance,
        reviewAvg: i?.fields?.reviewAvg,
        reviewNum: i?.fields?.reviewNum,
      })),
    })),
    valuePropCardContent: valuePropCardContent?.map((obj) => {
      return {
        cardImage: obj.fields?.cardImage?.fields?.file?.url
          ? `https:${obj.fields?.cardImage.fields.file.url}`
          : '',
        cardHeadline: obj.fields?.cardHeadline,
        cardSubHeadline: obj.fields?.cardSubHeadline,
        cardDescription: obj.fields?.cardDescription,
      };
    }),
    valuePropCardContentAlt: valuePropCardContentAlt?.map((obj) => {
      return {
        cardImage: obj.fields?.cardImage?.fields?.file?.url
          ? `https:${obj.fields?.cardImage.fields.file.url}`
          : '',
        cardHeadline: obj.fields?.cardHeadline,
        cardSubHeadline: obj.fields?.cardSubHeadline,
        cardDescription: obj.fields?.cardDescription,
        links: obj.fields?.links,
      };
    }),
    statBlockProps: select ? select : [],
    heading: heading,
    subHeading: subHeading,
    contact1Image: `https:${contact1Image?.fields?.file?.url}`,
    contact2Image: `https:${contact2Image?.fields?.file?.url}`,
    className: block?.className || null,
  };

  // Search Hero

  // adds props that do not exist in BlockMap that are equal to itself
  for (const prop in block.fields) {
    if (!BlockMap[prop]) {
      BlockMap[prop] = block.fields[prop];
    }
  }
  return BlockMap as T;
};
